import $ from 'jquery';
import 'slick-carousel';

const Tabs = () => {

    // Find the wrapping div around this set of tabs
    const tabs = document.querySelector('[data-tabs]');
    // Find the navigation links for these tabs
    const tab_links = tabs.querySelectorAll('[data-tab-link]');
    // Fetch each tab available within this set of tabs
    const tab_content = tabs.querySelectorAll('[data-tab]');
    // Var to hold any instances of ACF maps within tabs
    const tab_map = tabs.querySelector('[data-tab-map]');
    // Var to hold any sliders within the tabs
    const tab_sliders = tabs.querySelectorAll('[data-tab-slider]');
    // Var to hold any slider navs within the tabs
    const tab_navs = tabs.querySelectorAll('[data-tab-nav]');

    // Using the index of the tab, conditionally show and hide the tabs
    function displayCurrentTab(current) {
        // Loop through each tab by index to show or hide
        for (let i = 0; i < tab_content.length; i++) {
            // If the index matches that passed into the function, add display: block
            // to this tab, otherwise hide this
            tab_content[i].style.display = (current === i) ? 'block' : 'none';
        }
    }

    // Initialise the tabs by selecting the first tab as active
    displayCurrentTab(0);

    // Loop through each tab link to add/remove active states
    tab_links.forEach(tab_link => {

        tab_link.addEventListener('click', event => {
            // Stop the default behaviour of the link
            event.preventDefault();

            // Store the clicked tab link attribute for which tab to show
            let select_tab = event.target.getAttribute('data-tab-link');
            
            // Toggle the tabs
            toggleTabs(select_tab);
        });
    });

    function toggleTabs(select_tab) {

        // If this has a value, proceed
        if (select_tab) {

            // Loop through each tab link to add/remove active states
            tab_links.forEach(tab_link => {  

                // If the data attribute matches the tab we just clicked, add the
                // is-active class to the tab
                if (tab_link.getAttribute('data-tab-link') == select_tab) {
                    tab_link.classList.add('is-active');
                } else {
                    // Otherwise remove the active state from the tab
                    tab_link.classList.remove('is-active');
                }
            });

            // Now loop through each tab content elements
            for (let i = 0; i < tab_content.length; i++) {

                // Get the tab content data attribute value
                let tab_title = tab_content[i].getAttribute('data-tab');

                // If it has a value, proceed
                if (typeof tab_title != "undefined" && tab_title != null) {

                    // If the attribute of the tab content matches that of the tap link,
                    // this is the tab we need to show
                    if (select_tab === tab_content[i].getAttribute('data-tab')) {
                        
                        // Display the current tab to the end user
                        displayCurrentTab(i);

                        // If we have any maps inside of our tabs, we need to run this code
                        if (typeof tab_map != "undefined" && tab_map != null) {
                            // This forces a refresh of the map size/display as there are known
                            // issues with maps whose initial state is display: none
                            // see notes section here: https://www.advancedcustomfields.com/resources/google-map/
                            google.maps.event.trigger(tab_map, 'resize');
                        }

                        // If we have any sliders within our tabs, resize these to avoid height issues
                        if (typeof tab_sliders != "undefined" && tab_sliders != null) {
                            
                            tab_sliders.forEach(tab_slider => {
                                $(tab_slider).slick('setPosition');
                            });

                            if (typeof tab_navs != "undefined" && tab_navs != null) {
                            
                                tab_navs.forEach(tab_nav => {
                                    $(tab_nav).slick('setPosition').slick('refresh');
                                });
                            }
                        }
                        
                        break;
                    }
                }
            }
        }

    }

}

export default Tabs;